export const locale = {
  lang: "vi",
  data: {
    NAV: {
      DASHBOARDS: "Tổng quan",
      MASTER_DATA: "Danh mục",
      AUTHEN: "Hệ thống",
      LOOKUP: "Tra cứu",
      // PLANT: "Thực vật chí",
      EXTENSION: "Tiện ích",
      // PLANT_LIST: {
      //   PLANT_STRUCTURE: "Cấu trúc Taxon Thực vật chí",
      //   PLANT_STRUCTURE_LIST: {
      //     PLANT_MANAGER: "Quản lý kiểm tra cấu trúc Taxon TVC",
      //   },
      // },
      READ_RECORD: "Gỡ băng",
      REPORT: "Báo cáo",
      ANIMAL: "Động vật chí",
      PLANT: "Thực vật chí",
      PUBLISH: {
        PUBLISH_TITLE: "Quản lý xuất bản",
        NEWS_AUTHOR: "Tác giả bài viết",
        NEWS_MANAGER: {
          NEWS_MANAGER_TITLE: "Quản lý bài viết",
          NEWS: "Danh sách bài viết",
          NEWS_EDITER: "Danh sách biên tập",
          NEWS_BROWSING: "Danh sách kiểm duyệt",
          TAG: "Danh sách Tag tin tức",
          NEWS_PUBLISH:"Danh sách xuất bản"
        },
        CATEGORIES:{
          CATEGORY_TITLE: "Danh mục bài viết",
          CATEGORY_PAGE: "Danh mục trang",
          CATEGORY_NEWS: "Danh mục tin tức",
        },
        NEWS_COMMENT:"Danh sách bình luận",
        CONTACT: "Liên hệ",
        MENU: "Menu",
      },
      MASTER_DATA_LIST: {
        PROVINCE: "Tỉnh, Thành phố",
        DISTRICT: "Quận, Huyện, Thị xã",
        WARD: "Xã, Phường, Thị Trấn",
        ORGANIZATION: "Phòng ban",
        TITLE: "Chức danh",
        MEET_ROOM: "Phòng họp",
        TABLE_TYPE: "Loại hình bàn họp",
        MEET_GROUP: "Nhóm họp",
        MEET_TYPE: "Loại hình cuộc họp",
        NOTIFICATION_TEMPLATE: "Mẫu thông báo",
        //huy
        PUBLISHING: "Nhà xuất bản",
        AUTHOR: "Tác giả",
        //huy
        BOOK: "Sách",
        GROUP_PROVICE: "Địa giới hành chính",
      },
      LOOKUP_LIST: {
        SEARCH_PLANT: "Tra cứu dữ liệu thực vật chí",
        SEARCH_ANIMAL: "Tra cứu dữ liệu động vật chí",
      },
      AUTHEN_LIST: {
        GROUP_USER: "Nhóm quyền người dùng",
        FUNCTION: "Chức năng",
        ACTION: "Hành động",
        USER: "Người dùng hệ thống",
        DIARYHISTORY: "Nhật ký hệ thống",
        SETTINGS: "Cài đặt chung",
        VIEWSMANAGER: "Quản lý lượt xem",
        CONFIGURATIONSYSTEM: "Cấu hình hệ thống",
        UPLOAD: "Quản lý file tải lên",
        STORAGE_MANAGER:{
          STORAGE_TITLE: "Quản lý tài liệu",
          STORAGE: " Lưu trữ tài liệu phòng ban",
          STORAGE_COMMON: "Quản lý và chia sẻ dữ liệu dùng chung",
        },
      },
      REPORT_LIST: {
        ANIMAL_TAXONOMY_STRUCTURE: "Cấu trúc Taxon ĐVC",
        ANIMAL_DATA_STRUCTURE: "Danh sách các loài ĐVC",
        ANIMAL_DATA_TAXONOMY_STRUCTURE: "Các loài ĐVC theo cấu trúc Taxon",
        PLANT_TAXONOMY_STRUCTURE: "Cấu trúc Taxon TVC",
        PLANT_DATA_STRUCTURE: "Danh sách các loài TVC",
        PLANT_DATA_TAXONOMY_STRUCTURE: "Các loài TVC theo cấu trúc Taxon",
        AUTH: "Số lượng truy cập hệ thống",
        VIEWSMANAGER: "Số lượt đọc theo kỳ",
      },
      ANIMAL_LIST: {
        TAXONOMY_STRUCTURE: "Cấu trúc phân bậc",
        DATA_STRUCTURES: "Cấu trúc dữ liệu",
        ANIMAL_DETAIL: {
          LIST_DRAFT_TAXONOMY_STRUCTURE: "Danh sách nhập liệu",
          LIST_CHECK_TAXONOMY_STRUCTURE: "Danh sách kiểm tra",
          LIST_APPROVE_TAXONOMY_STRUCTURE: "Danh sách chờ duyệt",
          LIST_ANNOUNCED_TAXONOMY_STRUCTURE: "Danh sách công bố",
          LIST_HISTORY_TAXONOMY_STRUCTURE: "Lịch sử cập nhật",
          LIST_EXPERT_TAXONOMY_STRUCTURE: "Danh sách cần góp ý",
          LIST_ASSIGN_TAXONOMY_STRUCTURE: "Danh sách giao việc",

          LIST_DRAFT_DATA: "Danh sách nhập liệu",
          LIST_CHECK_DATA: "Danh sách kiểm tra",
          LIST_APPROVE_DATA: "Danh sách chờ duyệt",
          LIST_ANNOUNCED_DATA: "Danh sách công bố",
          LIST_EXPERT_DATA: "Danh sách cần góp ý",
          LIST_ASSIGN_DATA: "Danh sách giao việc",
          LIST_HISTORY_DATA: "Lịch sử cập nhật",
        },
      },

      PLANT_LIST: {
        CLASSIFICATION_STRUCTURE: "Cấu trúc phân bậc",
        DATA_STRUCTURES: "Cấu trúc dữ liệu",
        PLANT_DETAIL: {
          LIST_DRAFT_TAXONOMY_STRUCTURE: "Danh sách nhập liệu",
          LIST_CHECK_TAXONOMY_STRUCTURE: "Danh sách kiểm tra",
          LIST_APPROVE_TAXONOMY_STRUCTURE: "Danh sách chờ duyệt",
          LIST_ANNOUNCED_TAXONOMY_STRUCTURE: "Danh sách công bố",
          LIST_HISTORY_TAXONOMY_STRUCTURE: "Lịch sử cập nhật",
          LIST_EXPERT_TAXONOMY_STRUCTURE: "Danh sách cần góp ý",
          LIST_ASSIGN_TAXONOMY_STRUCTURE: "Danh sách giao việc",

          LIST_ASSIGN_DATA_STRUCTURE: "Danh sách giao việc",
          LIST_DRAFT_DATA_STRUCTURE: "Danh sách nhập liệu",
          LIST_CHECK_DATA_STRUCTURE: "Danh sách kiểm tra",
          LIST_APPROVE_DATA_STRUCTURE: "Danh sách chờ duyệt",
          LIST_ANNOUNCED_DATA_STRUCTURE: "Danh sách công bố",
          LIST_HISTORY_DATA_STRUCTURE: "Lịch sử cập nhật",
          LIST_EXPERT_DATA_STRUCTURE: "Danh sách cần góp ý",
        },
      },
    },
  },
};
